





import Vue from 'vue'

export default Vue.extend({
  name: 'DdGlobalSearchLoading',
  props: {
    /**
     * Activate search
     */
    searchActive: {
      type: Boolean,
      required: true,
    },
    /**
     * Activate search
     */
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
})
